import { render } from "./LottoPromoSidebar.vue?vue&type=template&id=b31631c4&scoped=true"
import script from "./LottoPromoSidebar.vue?vue&type=script&lang=js"
export * from "./LottoPromoSidebar.vue?vue&type=script&lang=js"

import "./LottoPromoSidebar.vue?vue&type=style&index=0&id=b31631c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b31631c4"]])

export default __exports__